import * as actions from './actions';
import update from 'react/lib/update';

export const initState = {
  chatMessages: [],
  isFetching: false,
  stopLoadingMoreChatmessages: false,
}

export default function (state = initState, action) {
  switch (action.type) {
    case actions.FETCH_CHATMESSAGE_REQUEST:
      return update(state, {
        isFetching: {
          $set: true
        }
      });
    case actions.FETCH_CHATMESSAGE_SUCCESS:
      return update(state, {
        isFetching: {
          $set: false
        },
        chatMessages: {
          $push: action.chatMessages
        }
      });
    case actions.FETCH_CHATMESSAGE_SUCCESS_INIT:
      return update(state, {
        isFetching: {
          $set: false
        },
        chatMessages: {
          $set: action.chatMessages
        }
      });
    case actions.FETCH_CHATMESSAGE_FAILURE:
      return update(state, {
        isFetching: {
          $set: false
        }
      });
    case actions.ADD_MESSAGE_REQUEST:
      return update(state, {
        chatMessages: {
          $splice: [[0, 0, action.chatMessage]]
        }
      });
    case actions.ADD_MESSAGE_FAILURE:
      return update(state, {
        chatMessages: {
          $splice: [[0, 1]]
        }
      });
    case 'KILL_WORKPLACE':
      return initState
    case 'NO_MORE_CHAT_MESSAGES':
      return update(state, {
        stopLoadingMoreChatmessages: {
          $set: true
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/Chat/reducer.js